// DEPRECATED PAGE
import { useState, useEffect, useRef } from 'react';
import {
  useOutletContext,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import './Collections.css';
import Modal from '../../components/common/Modal';
import videoStatus from '../../utils/videoStatusUtils';
import DataTableCollections from './DataTableCollections';
import { createCollection } from './Resources';
import '@aws-amplify/ui-react/styles.css';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Backdrop, CircularProgress } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { deprecatedApiInterceptor } from '../../App';
import { SubjectLayout } from 'layouts/SubjectLayout';
import * as moment from 'moment';

import { useAppProviderStore } from 'store/appProviderCopyStore';
import { CRUD_STATES } from 'constants/app';
import ModalTitle from '../../components/modals/ModalTitle';
import { Table } from 'components/Table';
import { defaultCollectionFilters } from 'constants/filters';
import { useTableFilterStore } from 'store/tableFilterStore';
import { useNotification } from 'hooks/useNotification';

function CollectionsNew(props) {
  const { setActiveStep, setCancelUpload } = useAppProviderStore();
  const [auth, setAuth] = useOutletContext();
  const [searchParams] = useSearchParams();
  const { setNotify } = useNotification();
  const { showConfirmationButton } = useState(true);

  const [totalItems, setTotalItems] = useState(); //total de resultados retornado pela consulta de usuários
  const [totalPages, setTotalPages] = useState(); //total de páginas que temos para exibir
  const [itemsPerPage, setItemsPerPage] = useState(); //exibicao da posicao de itens que está sendo exibido no footer da página
  const [itemsInitialPage, setItemsInitialPage] = useState(1);
  const [actualPage, setActualPage] = useState(1); //numero exibido indicando qual a pagina atual que ele está
  const [userItems, setUserItems] = useState([]); //resultado da consulta
  const offSetItems = useRef(0);
  const { collectionPageFilters, setCollectionPageFilters } =
    useTableFilterStore();

  const [isLoading, setIsLoading] = useState(false);
  const [openTitle, setOpenTitle] = useState(false);
  //FILTER'S STATES
  //VALUE OF UNITS AND CHANNELS

  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });

  const [pending, setPending] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    setActiveStep(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [filterPath, setFilterPath] = useState(() => {
    if (!searchParams?.size && collectionPageFilters.qs) {
      return `&${collectionPageFilters.qs}`;
    }
    if (!searchParams?.size) return;
    let queryPath = '';
    const channel =
      searchParams.get('canal') && JSON.parse(searchParams.get('canal'));
    const unit =
      searchParams.get('unidade') && JSON.parse(searchParams.get('unidade'));

    if (channel) queryPath += `&channelId=${channel.value}`;
    if (unit) queryPath += `&unitId=${unit.value}`;

    return queryPath;
  });
  const [initialFilter] = useState(() => {
    if (!searchParams?.size && collectionPageFilters.object) {
      return collectionPageFilters.object;
    }
    if (!searchParams?.size) return;

    const filterInitialArray = [];
    const channel =
      searchParams.get('canal') && JSON.parse(searchParams.get('canal'));

    channel &&
      filterInitialArray.push({
        field: 'channel',
        label: 'Canal',
        chipValue: channel.label,
        value: channel.value,
      });

    const unit =
      searchParams.get('unidade') && JSON.parse(searchParams.get('unidade'));

    unit &&
      filterInitialArray.push({
        field: 'unit',
        label: 'Unidade',
        chipValue: unit.label,
        value: unit.value,
      });

    return filterInitialArray;
  });

  useEffect(() => {
    // Este trecho de código será executado após filterPath ser atualizado
    setActiveStep(1);
    offSetItems.current = 0;
    setItemsInitialPage(1);
    collectionDataTableGetItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPath]);

  const handleOpen = async action => {
    setOpenTitle(true);
    setCancelUpload(false);
  };

  const handleEditAndViewVideo = action => {
    // return setNotify({
    //   isOpen: true,
    //   message: 'Funcionalidade ainda não disponível.',
    //   type: 'info',
    //   title: (
    //     <span>
    //       Em desenvolvimento <ConstructionIcon />
    //     </span>
    //   ),
    // });

    setIsLoading(true);
    if (
      action.action === CRUD_STATES.EDIT &&
      (action.status === 'PUBLISHED' || action.status === 'EXPIRED')
    ) {
      const idToken = auth.getIdToken().getJwtToken();
      const apiName = 'admin';
      const path = `/admin/collections/${action?.id}/versions`;

      const data = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${idToken}`,
        },
      };
      deprecatedApiInterceptor
        .post(
          newToken => {
            setAuth(newToken);
          },
          apiName,
          path,
          data
        )
        .then(resp => {
          setIsLoading(false);
          navigate(`/colecao-novo/${action?.id}/${resp.version}`, {
            state: {
              action: action.action,
              id: action?.id,
              version: action?.version,
            },
          });
        })
        .catch(error => {
          setIsLoading(false);
          setConfirmDialogAction({ isOpen: false });
          const errorJson = error.request.response;
          const parseJson = JSON.parse(errorJson);
          setNotify({
            isOpen: true,
            message: parseJson.message,
            type: 'error',
            title: 'Ops! Algo deu errado...',
          });
        });
      // eslint-disable-next-line no-unreachable
    } else {
      setIsLoading(true);
      navigate(`/colecao-novo/${action?.id}/${action?.version}`, {
        state: {
          action: action.action,
          id: action.id,
          version: action?.version || 1,
        },
      });
      setIsLoading(false);
    }
  };

  const handleArchiveCollection = async (collectionId, version, title) => {
    setIsLoading(true);

    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path = `/admin/collections/${collectionId}/versions/${version}/status/archived`;

    const data = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    deprecatedApiInterceptor
      .patch(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        data
      )
      .then(resp => {
        setTimeout(() => {
          setConfirmDialogAction({ isOpen: false });
          setNotify({
            isOpen: true,
            message: `Coleção "${title}" arquivada com sucesso!`,
            type: 'success',
            title: 'Sucesso!',
          });
          setIsLoading(false);
          collectionDataTableGetItems();
        }, 4000);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        setConfirmDialogAction({ isOpen: false });
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  };

  const handleRemoveCollection = async (collectionId, version, title) => {
    setIsLoading(true);
    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path = `/admin/collections/${collectionId}/versions/${version}`;
    const data = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    deprecatedApiInterceptor
      .del(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        data
      )
      .then(resp => {
        setTimeout(() => {
          setConfirmDialogAction({ isOpen: false });
          setNotify({
            isOpen: true,
            message: `A coleção "${title}" foi removida com sucesso!`,
            type: 'success',
            title: 'Sucesso!',
          });
          setIsLoading(false);
          collectionDataTableGetItems();
        }, 4000);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        setConfirmDialogAction({ isOpen: false });
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  };

  const columns = [
    {
      id: 1,
      name: 'Versão',
      width: '80px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.version === undefined
              ? 'datatable_prevent_click'
              : 'video_datatable_version'
          }>
          {row.version === undefined ? '-' : row.version}
        </div>
      ),
    },
    {
      id: 2,
      name: '',
      width: '30px',
      center: 'true',
      cell: row => (
        <div
          className="user_datatable_pointer"
          onClick={() => {
            handleEditAndViewVideo({
              action: CRUD_STATES.VIEW,
              id: row.id,
              version: row.version,
              status: row.status,
            });
          }}>
          {row.status === 'DRAFT' ? (
            ''
          ) : row.status === 'FAILED' ? (
            ''
          ) : (
            <img
              src="/img/videosDataTable/eye.svg"
              alt="Visualizar"
              className="eye-icon"
              style={{ width: '25px', height: '25px' }}
            />
          )}
        </div>
      ),
    },
    {
      id: 3,
      name: '',
      width: '30px',
      center: 'true',
      cell: row => (
        <div
          className="user_datatable_pointer"
          onClick={() => {
            handleEditAndViewVideo({
              action: CRUD_STATES.EDIT,
              id: row.id,
              version: row.version,
              status: row.status,
            });
            // alert("Funcionalidade ainda não implementada!")
          }}>
          {row.status === 'ARCHIVED' ? (
            ''
          ) : row.status === 'TRANSCODING' ? (
            ''
          ) : (
            <img
              src="/img/videosDataTable/editpencil.svg"
              alt="Editar"
              style={{ width: '25px', height: '25px' }}
            />
          )}
        </div>
      ),
    },
    {
      id: 4,
      name: '',
      width: '30px',
      center: 'true',
      cell: row => (
        <div className="user_datatable_pointer">
          {row.status === 'ARCHIVED' ? (
            ''
          ) : row.status === 'TRANSCODING' ? (
            ''
          ) : row.status === 'DRAFT' ? (
            <img
              src="/img/videosDataTable/trash.svg"
              onClick={() =>
                setConfirmDialogAction({
                  isOpen: true,
                  title: (
                    <div className="modalTitleText">
                      Remover o título {row.title}?
                    </div>
                  ),
                  subTitle: (
                    <div className="modalBodyText">
                      Você está removendo o título {row.title}
                      permanentemente.
                    </div>
                  ),
                  children: (
                    <div className="modalRemoveItem">
                      <DeleteOutlineOutlinedIcon
                        color="error"
                        fontSize="12px"
                      />
                    </div>
                  ),
                  confirmTextButton: 'Remover',
                  color: 'error',
                  onConfirm: () => {
                    handleRemoveCollection(row.id, row.version, row.title);
                  },
                  showConfirmationButton: { showConfirmationButton },
                  closeTextButton: 'Cancelar',
                })
              }
              alt="Remover"
              style={{ width: '25px', height: '25px' }}
            />
          ) : row.status === 'FAILED' ? (
            <img
              className="trash-icon"
              src="/img/videosDataTable/trash.svg"
              onClick={() =>
                setConfirmDialogAction({
                  isOpen: true,
                  title: (
                    <div className="modalTitleText">
                      Remover o título {row.title}?
                    </div>
                  ),
                  subTitle: (
                    <div className="modalBodyText">
                      Você irá Remover o título {row.title} permanentemente.
                    </div>
                  ),
                  children: (
                    <div className="modalResendSentEmail">
                      <InfoOutlinedIcon color="primary" fontSize="12px" />
                    </div>
                  ),
                  confirmTextButton: 'Remover',
                  color: 'error',
                  onConfirm: () => {
                    handleRemoveCollection(row.id, row.version, row.title);
                  },
                  showConfirmationButton: { showConfirmationButton },
                  closeTextButton: 'Cancelar',
                })
              }
              alt="Remover"
              style={{ width: '25px', height: '25px' }}
            />
          ) : (
            <img
              src="/img/videosDataTable/archive.svg"
              onClick={() =>
                setConfirmDialogAction({
                  isOpen: true,
                  title: (
                    <div className="modalTitleText">
                      Arquivar o título {row.title}?
                    </div>
                  ),
                  subTitle: (
                    <div className="modalBodyText">
                      Você irá arquivar o título {row.title} permanentemente.
                    </div>
                  ),
                  children: (
                    <div className="modalResendSentEmail">
                      <InfoOutlinedIcon color="primary" fontSize="12px" />
                    </div>
                  ),
                  confirmTextButton: 'Arquivar',
                  color: 'primary',
                  onConfirm: () => {
                    handleArchiveCollection(row.id, row.version, row.title);
                  },
                  showConfirmationButton: { showConfirmationButton },
                  closeTextButton: 'Cancelar',
                })
              }
              alt="Arquivar"
              style={{ width: '25px', height: '25px' }}
            />
          )}
        </div>
      ),
    },
    {
      id: 5,
      name: 'Título',
      cell: row => (
        <div
          className={row.title === undefined ? 'datatable_prevent_click' : ''}>
          {row.title === undefined ? '-' : row.title}
        </div>
      ),
      width: '500px',
    },
    {
      id: 6,
      name: 'Status',
      center: 'true',
      cell: row => (
        <div
          className={row.status === undefined ? 'datatable_prevent_click' : ''}>
          {row.status === undefined ? '-' : videoStatus[row.status]}
        </div>
      ),
      width: '200px',
    },
    {
      id: 7,
      name: 'N.º vídeos',
      center: 'true',
      cell: row => (
        <div
          className={
            row.videos === undefined
              ? 'datatable_prevent_click'
              : row.videos.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  A coleção <strong>{row.title}</strong> está associada aos
                  seguintes vídeos:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.videos.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/videos_icon.svg"
                          alt="Personalidades Associadas"
                          style={{ width: '18px', height: '23px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.video.title}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Videos associados({row.videos.length}
                    ).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.videos === undefined
            ? '-'
            : row.videos.length === 0
              ? '-'
              : row.videos.length}
        </div>
      ),
      width: '115px',
    },
    {
      id: 8,
      name: 'Crédito (Personalidade)',
      center: 'true',
      selector: row =>
        row.personalitiesCredits === undefined
          ? 'datatable_prevent_click'
          : row.personalitiesCredits.length === 0
            ? 'datatable_prevent_click'
            : row.personalitiesCredits.length,
      width: '287px',
      cell: row => (
        <div
          className={
            row.personalitiesCredits === undefined
              ? 'datatable_prevent_click'
              : row.personalitiesCredits.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  A coleção <strong>{row.title}</strong> está associada as
                  seguintes personalidades (Crédito):
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.personalitiesCredits.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/personalidade_icon.svg"
                          alt="Personalidades Associadas"
                          style={{ width: '18px', height: '23px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Personalidades associadas ({row.personalitiesCredits.length}
                    ).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.personalitiesCredits === undefined
            ? '-'
            : row.personalitiesCredits.length === 0
              ? '-'
              : row.personalitiesCredits.length}
        </div>
      ),
    },
    {
      id: 9,
      name: 'Com Quem (Personalidade)',
      center: 'true',
      selector: row =>
        row.personalities === undefined
          ? 'datatable_prevent_click'
          : row.personalities.length === 0
            ? 'datatable_prevent_click'
            : row.personalities.length,
      width: '287px',
      cell: row => (
        <div
          className={
            row.personalities === undefined
              ? 'datatable_prevent_click'
              : row.personalities.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  A coleção <strong>{row.title}</strong> está associada as
                  seguintes personalidades (Com Quem?):
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.personalities.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/personalidade_icon.svg"
                          alt="Personalidades Associadas"
                          style={{ width: '18px', height: '23px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Personalidades associadas ({row.personalities.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.personalities === undefined
            ? '-'
            : row.personalities.length === 0
              ? '-'
              : row.personalities.length}
        </div>
      ),
    },
    {
      id: 10,
      name: 'Palavras-Chave',
      selector: row =>
        row.keywords === undefined
          ? 'datatable_prevent_click'
          : row.keywords.length === 0
            ? 'datatable_prevent_click'
            : row.keywords.length,
      width: '287px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.keywords === undefined
              ? 'datatable_prevent_click'
              : row.keywords.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  A coleção <strong>{row.title}</strong> está associada as
                  seguintes palavras-chave:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.keywords.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/palavras_chave_icon.svg"
                          alt="Unidades Associadas"
                          style={{ width: '23px', height: '28px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.key}
                        secondary={'(' + item.value + ')'}
                        className="listItemTextKeyWords"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Palavras-Chave associadas ({row.keywords.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.keywords === undefined
            ? '-'
            : row.keywords.length === 0
              ? '-'
              : row.keywords.length}
        </div>
      ),
    },
    {
      id: 12,
      name: 'Unidade',
      selector: row =>
        row.units === undefined
          ? 'datatable_prevent_click'
          : row.units.length === 0
            ? 'datatable_prevent_click'
            : row.units.length,
      width: '115px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.units === undefined
              ? 'datatable_prevent_click'
              : row.units.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  A coleção <strong>{row.title}</strong> está associada as
                  seguintes unidades:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.units.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/unidades_sesc_icon.svg"
                          alt="Unidades Associadas"
                          style={{ width: '30px', height: '35px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Unidades associadas ({row.units.length}).{' '}
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.units === undefined
            ? '-'
            : row.units.length === 0
              ? '-'
              : row.units.length}
        </div>
      ),
    },
    {
      id: 13,
      name: 'Canal',
      selector: row =>
        row.channels === undefined
          ? 'datatable_prevent_click'
          : row.channels.length === 0
            ? 'datatable_prevent_click'
            : row.channels.length,
      width: '115px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.channels === undefined
              ? 'datatable_prevent_click'
              : row.channels.length === 0
                ? 'datatable_prevent_click'
                : 'user_datatable_cell_hyperlink'
          }
          onClick={() =>
            setConfirmDialogAction({
              isOpen: true,
              scroll: 'paper',
              title: (
                <span
                  style={{
                    fontSize: '14px',
                    opacity: '0.8',
                    fontWeight: '300',
                    color: '#000',
                  }}>
                  {' '}
                  A coleção <strong>{row.title}</strong> está associada aos
                  seguintes canais:
                </span>
              ),
              subTitle: (
                <List sx={{ pt: 0 }}>
                  {row.channels.map(item => (
                    <ListItem
                      disableGutters
                      key={item}
                      className="listItemRoot">
                      <ListItemAvatar className="listItemAvatar">
                        <img
                          src="/img/navbar_cockpit/canais_sesc_icon.svg"
                          alt="Canais associados"
                          style={{ width: '20px', height: '25px' }}
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.name}
                        className="listItemText"
                      />
                    </ListItem>
                  ))}
                </List>
              ),
              children: (
                <>
                  <span className="modalResendSentEmail">
                    <InfoOutlinedIcon color="primary" fontSize="12px" />
                  </span>
                  <span
                    style={{
                      marginTop: '15px',
                      paddingRight: 8,
                      fontSize: '17px',
                    }}>
                    Canais associados ({row.channels.length}).
                  </span>
                </>
              ),
              closeTextButton: 'Fechar',
            })
          }>
          {row.channels === undefined
            ? '-'
            : row.channels.length === 0
              ? '-'
              : row.channels.length}
        </div>
      ),
    },
    {
      id: 14,
      name: 'Editor',
      selector: row =>
        row.updatedBy === undefined
          ? ''
          : row.updatedBy.length === 0
            ? ''
            : row.updatedBy.length,
      width: '333px',
      center: 'true',
      cell: row => (
        <div
          className={
            row.updatedBy === undefined
              ? 'datatable_prevent_click'
              : row.updatedBy.length === 0
                ? 'datatable_prevent_click'
                : ''
          }>
          {row.updatedBy === undefined
            ? '-'
            : row.updatedBy.length === 0
              ? '-'
              : row.updatedBy.name}
        </div>
      ),
    },
    {
      id: 15,
      name: 'Última atualização',
      center: 'true',
      selector: row => moment(row.updatedAt).format('HH:mm DD/MM/YYYY'),
      cell: row => (
        <div
          className={
            row.updatedAt === undefined ? 'datatable_prevent_click' : ''
          }>
          {row.updatedAt === undefined
            ? '-'
            : moment(row.updatedAt).format('HH:mm DD/MM/YYYY')}
        </div>
      ),
      width: '192px',
    },
  ];

  const videoDataTablePagination = arrowDirection => {
    setPending(true);
    if (arrowDirection === 'right') {
      offSetItems.current += 10;
    } else if (arrowDirection === 'left') {
      offSetItems.current -= 10;
    }

    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path =
      '/admin/collections?limit=10&sortBy=name&offset=' +
      offSetItems.current +
      filterPath;

    const datab = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    deprecatedApiInterceptor
      .get(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        datab
      )
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.collectionList);

        if (arrowDirection === 'right') {
          setItemsInitialPage(itemsInitialPage + 10);
          setActualPage(actualPage + 1);
          setItemsPerPage(itemsPerPage + resp.collectionList.length);
          setPending(false);
        } else if (arrowDirection === 'left') {
          setItemsPerPage(itemsPerPage - userItems.length);
          setItemsInitialPage(itemsInitialPage - 10);
          setActualPage(actualPage - 1);
          setPending(false);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const collectionDataTableGetItems = () => {
    setPending(true);
    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path =
      '/admin/collections?limit=10&sortBy=name&offset=' +
      offSetItems.current +
      filterPath;
    const datab = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    deprecatedApiInterceptor
      .get(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        datab
      )
      .then(resp => {
        setTotalItems(resp.totalItemsCountFiltered);
        setUserItems(resp.collectionList);

        if (resp.collectionList.length === 0) {
          setItemsInitialPage(0);
        }

        if (resp.totalItemsCountFiltered <= 10) {
          setItemsPerPage(resp.totalItemsCountFiltered);
          setTotalPages(1);
        } else {
          setItemsPerPage(resp.collectionList.length);
          setTotalPages(Math.ceil(resp.totalItemsCountFiltered / 10));
        }
        setPending(false);
      })
      .catch(error => {
        console.log(error);
        setPending(false);
      });
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: '50px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#475467',
        fontWeight: '500',
        backgroundColor: 'var(--gray-50, #F9FAFB)',
        width: 'auto',
      },
    },
    cells: {
      style: {
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#6F6B7D',
        // backgroundColor: "var(--gray-50, #F9FAFB)",
        width: 'auto',
      },
    },
  };

  const collectionDataTableGetVersions = async videoId => {
    const idToken = auth.getIdToken().getJwtToken();
    const apiName = 'admin';
    const path = `/admin/collections/${videoId}/versions`;

    const datab = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${idToken}`,
      },
    };
    return deprecatedApiInterceptor
      .get(
        newToken => {
          setAuth(newToken);
        },
        apiName,
        path,
        datab
      )
      .then(resp => {
        return resp;
      })
      .catch(error => {
        console.log(error);
        return 'error';
      });
  };

  const ExpandedComponent = ({ data }) => {
    const [resultados, setResultados] = useState(null);

    useEffect(() => {
      const collectionDataTableVersions = async () => {
        try {
          const user = await collectionDataTableGetVersions(data.id);
          setResultados(user);
        } catch (error) {
          console.log(error);
        }
      };
      collectionDataTableVersions();
    }, [data]);
    return resultados ? (
      resultados === 'error' ? (
        <div className="row_version_body" id="expanded-collection">
          <div className="table-videos-row">
            <div className="video_version_line">
              <div className="video_version_right_line"></div>
            </div>
            <div className="video_version_line">
              <div className="video_version_bottom_line"></div>
            </div>
            <div className="video_version_dot"></div>
            Houve um problema ao buscar outras versões para o título:{' '}
            <div className="version_title_bold">{data.title}</div>.
          </div>
        </div>
      ) : resultados.itemsCount > 1 ? (
        resultados.versionList.map((version, index) => {
          // eslint-disable-next-line eqeqeq
          if (version.version != data.version) {
            return (
              <div
                className="row_version_body"
                key={index}
                id={version.version}>
                <div className="table-videos-row">
                  <div className="video_version_line">
                    <div className="video_version_right_line"></div>
                  </div>
                  <div className="video_version_line">
                    <div className="video_version_bottom_line"></div>
                  </div>
                  <div className="video_version_dot"></div>

                  <div className="table-videos-col-version">
                    {version.version === undefined ? '-' : version.version}
                  </div>

                  <div
                    className={
                      version.status === 'DRAFT'
                        ? 'table-videos-col-icons_prevent'
                        : 'table-videos-col-icons'
                    }
                    onClick={() => {
                      handleEditAndViewVideo({
                        action: CRUD_STATES.VIEW,
                        id: version.id,
                        version: version.version,
                        status: version.status,
                      });
                    }}>
                    {version.status === 'DRAFT' ? (
                      ''
                    ) : version.status === 'FAILED' ? (
                      ''
                    ) : (
                      <img
                        className="eye-icon"
                        src="/img/videosDataTable/eye.svg"
                        alt="Visualizar"
                        style={{ width: '25px', height: '25px' }}
                      />
                    )}
                  </div>

                  <div
                    className={
                      version.status === 'ARCHIVED'
                        ? 'table-videos-col-icons-2_prevent'
                        : version.status === 'TRANSCODING'
                          ? 'table-videos-col-icons-2_prevent'
                          : 'table-videos-col-icons-2'
                    }
                    onClick={() => {
                      handleEditAndViewVideo({
                        action: CRUD_STATES.EDIT,
                        id: version.id,
                        version: version.version,
                        status: version.status,
                      });

                      // alert("Funcionalidade ainda não implementada!")
                    }}>
                    {version.status === 'ARCHIVED' ? (
                      ''
                    ) : version.status === 'TRANSCODING' ? (
                      ''
                    ) : (
                      <img
                        src="/img/videosDataTable/editpencil.svg"
                        alt="Editar"
                        style={{ width: '25px', height: '25px' }}
                      />
                    )}
                  </div>

                  <div
                    className={
                      version.status === 'ARCHIVED'
                        ? 'table-videos-col-icons-4_prevent'
                        : version.status === 'TRANSCODING'
                          ? 'table-videos-col-icons-4_prevent'
                          : 'table-videos-col-icons-4'
                    }>
                    {version.status === 'ARCHIVED' ? (
                      ''
                    ) : version.status === 'TRANSCODING' ? (
                      ''
                    ) : version.status === 'DRAFT' ? (
                      <img
                        id="collection-delete-draft"
                        src="/img/videosDataTable/trash.svg"
                        onClick={() =>
                          setConfirmDialogAction({
                            isOpen: true,
                            title: (
                              <div className="modalTitleText">
                                Remover o título {version.title}?
                              </div>
                            ),
                            subTitle: (
                              <div className="modalBodyText">
                                Você está removendo o título {version.title}
                                permanentemente.
                              </div>
                            ),
                            children: (
                              <div className="modalRemoveItem">
                                <DeleteOutlineOutlinedIcon
                                  color="error"
                                  fontSize="12px"
                                />
                              </div>
                            ),
                            confirmTextButton: 'Remover',
                            color: 'error',
                            onConfirm: () => {
                              handleRemoveCollection(
                                version.id,
                                version.version,
                                version.title
                              );
                            },
                            showConfirmationButton: { showConfirmationButton },
                            closeTextButton: 'Cancelar',
                          })
                        }
                        alt="Remover"
                        style={{ width: '25px', height: '25px' }}
                      />
                    ) : version.status === 'FAILED' ? (
                      <img
                        className="trash-icon"
                        src="/img/videosDataTable/trash.svg"
                        onClick={() =>
                          setConfirmDialogAction({
                            isOpen: true,
                            title: (
                              <div className="modalTitleText">
                                Remover o título {version.title}?
                              </div>
                            ),
                            subTitle: (
                              <div className="modalBodyText">
                                Você irá Remover o título {version.title}{' '}
                                permanentemente.
                              </div>
                            ),
                            children: (
                              <div className="modalResendSentEmail">
                                <DeleteOutlineOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </div>
                            ),
                            confirmTextButton: 'Remover',
                            color: 'error',
                            onConfirm: () => {
                              handleRemoveCollection(
                                version.id,
                                version.version,
                                version.title
                              );
                            },
                            showConfirmationButton: { showConfirmationButton },
                            closeTextButton: 'Cancelar',
                          })
                        }
                        alt="Remover"
                        style={{ width: '25px', height: '25px' }}
                      />
                    ) : (
                      <img
                        id="collection-archive-item"
                        src="/img/videosDataTable/archive.svg"
                        onClick={() =>
                          setConfirmDialogAction({
                            isOpen: true,
                            title: (
                              <div className="modalTitleText">
                                Arquivar o título {version.title}?
                              </div>
                            ),
                            subTitle: (
                              <div className="modalBodyText">
                                Você irá arquivar o título {version.title}
                                permanentemente.
                              </div>
                            ),
                            children: (
                              <div className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </div>
                            ),
                            confirmTextButton: 'Arquivar',
                            color: 'primary',
                            onConfirm: () => {
                              handleArchiveCollection(
                                version.id,
                                version.version,
                                version.title
                              );
                            },
                            showConfirmationButton: { showConfirmationButton },
                            closeTextButton: 'Cancelar',
                          })
                        }
                        alt="Arquivar"
                        style={{ width: '25px', height: '25px' }}
                      />
                    )}
                  </div>

                  <div className="table-videos-col-title">
                    {version.title === undefined ? '-' : version.title}
                  </div>

                  <div className="table-videos-col-status">
                    {version.status === undefined
                      ? '-'
                      : videoStatus[version.status]}
                  </div>

                  <div className="personalityC_margin">
                    <div
                      className={
                        version.personalitiesCredits === undefined
                          ? 'table-videos-col-personalityC_prevent'
                          : version.personalitiesCredits.length === 0
                            ? 'table-videos-col-personalityC_prevent'
                            : 'table-videos-col-personalityC'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              A coleção `{version.title}` está associado as
                              seguintes personalidades (Crédito):
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.personalitiesCredits.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/personalidade_icon.svg"
                                      alt="Personalidades Associadas"
                                      style={{ width: '18px', height: '23px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Personalidades associadas (
                                {version.personalitiesCredits.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.personalitiesCredits === undefined
                        ? '-'
                        : version.personalitiesCredits.length === 0
                          ? '-'
                          : version.personalitiesCredits.length}
                    </div>
                  </div>

                  <div className="personalityW_margin">
                    <div
                      className={
                        version.personalities === undefined
                          ? 'table-videos-col-personalityW_prevent'
                          : version.personalities.length === 0
                            ? 'table-videos-col-personalityW_prevent'
                            : 'table-videos-col-personalityW'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              A coleção `{version.title}` está associado as
                              seguintes personalidades (Com Quem?):
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.personalities.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/personalidade_icon.svg"
                                      alt="Personalidades Associadas"
                                      style={{ width: '18px', height: '23px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Personalidades associadas (
                                {version.personalities.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.personalities === undefined
                        ? '-'
                        : version.personalities.length === 0
                          ? '-'
                          : version.personalities.length}
                    </div>
                  </div>

                  <div className="keyword_margin">
                    <div
                      className={
                        version.keywords === undefined
                          ? 'table-videos-col-keyWord_prevent'
                          : version.keywords.length === 0
                            ? 'table-videos-col-keyWord_prevent'
                            : 'table-videos-col-keyWord'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              A coleção `{version.title}` está associado as
                              seguintes palavras-chave:
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.keywords.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/palavras_chave_icon.svg"
                                      alt="Unidades Associadas"
                                      style={{ width: '23px', height: '28px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.key}
                                    secondary={'(' + item.value + ')'}
                                    className="listItemTextKeyWords"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Palavras-Chave associadas (
                                {version.keywords.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.keywords === undefined
                        ? '-'
                        : version.keywords.length === 0
                          ? '-'
                          : version.keywords.length}
                    </div>
                  </div>

                  <div className="units_margin">
                    <div
                      className={
                        version.units === undefined
                          ? 'table-videos-col-units_prevent'
                          : version.units.length === 0
                            ? 'table-videos-col-units_prevent'
                            : 'table-videos-col-units'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              A coleção `{version.title}` está associado as
                              seguintes unidades:
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.units.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/unidades_sesc_icon.svg"
                                      alt="Unidades Associadas"
                                      style={{ width: '30px', height: '35px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Unidades associadas ({version.units.length}).{' '}
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.units === undefined
                        ? '-'
                        : version.units.length === 0
                          ? '-'
                          : version.units.length}
                    </div>
                  </div>

                  <div className="channels_margin">
                    <div
                      className={
                        version.channels === undefined
                          ? 'table-videos-col-channels_prevent'
                          : version.channels.length === 0
                            ? 'table-videos-col-channels_prevent'
                            : 'table-videos-col-channels'
                      }
                      onClick={() =>
                        setConfirmDialogAction({
                          isOpen: true,
                          scroll: 'paper',
                          title: (
                            <span
                              style={{
                                fontSize: '14px',
                                opacity: '0.8',
                                fontWeight: '300',
                                color: '#000',
                              }}>
                              {' '}
                              A coleção `{version.title}` está associado aos
                              seguintes canais:
                            </span>
                          ),
                          subTitle: (
                            <List sx={{ pt: 0 }}>
                              {version.channels.map(item => (
                                <ListItem
                                  disableGutters
                                  key={item}
                                  className="listItemRoot">
                                  <ListItemAvatar className="listItemAvatar">
                                    <img
                                      src="/img/navbar_cockpit/canais_sesc_icon.svg"
                                      alt="Canais associados"
                                      style={{ width: '20px', height: '25px' }}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={item.name}
                                    className="listItemText"
                                  />
                                </ListItem>
                              ))}
                            </List>
                          ),
                          children: (
                            <>
                              <span className="modalResendSentEmail">
                                <InfoOutlinedIcon
                                  color="primary"
                                  fontSize="12px"
                                />
                              </span>
                              <span
                                style={{
                                  marginTop: '15px',
                                  paddingRight: 8,
                                  fontSize: '17px',
                                }}>
                                Canais associados ({version.channels.length}).
                              </span>
                            </>
                          ),
                          closeTextButton: 'Fechar',
                        })
                      }>
                      {version.channels === undefined
                        ? '-'
                        : version.channels.length === 0
                          ? '-'
                          : version.channels.length}
                    </div>
                  </div>

                  <div className="table-videos-col-editor">
                    {version.updatedBy === undefined
                      ? '-'
                      : version.updatedBy.length === 0
                        ? '-'
                        : version.updatedBy.name}
                  </div>

                  <div className="table-videos-col-lastAtt">
                    {version.updatedAt === undefined
                      ? '-'
                      : moment(version.updatedAt).format('HH:mm DD/MM/YYYY')}
                  </div>
                </div>
              </div>
            );
          }
          return null;
        })
      ) : (
        <div className="row_version_body" id="expanded-collection">
          <div className="versions_not_found">
            <div className="video_version_line">
              <div className="video_version_right_line"></div>
            </div>
            <div className="video_version_line">
              <div className="video_version_bottom_line"></div>
            </div>
            <div className="video_version_dot"></div>
            Não foram encontradas outras versões para o título:{' '}
            <div className="version_title_bold">{data.title}</div>.
          </div>
        </div>
      )
    ) : (
      <div className="row_version_body" id="expanded-collection">
        <div className="table-videos-row row_notcontent_margin">
          Carregando...
        </div>
      </div>
    );
  };

  return (
    <SubjectLayout.Root id="main-collection">
      <SubjectLayout.Title>Coleções</SubjectLayout.Title>
      <SubjectLayout.IconButton
        onClick={() => {
          handleOpen({ action: CRUD_STATES.CREATE, id: '' });
        }}>
        Coleção
      </SubjectLayout.IconButton>

      <Backdrop
        open={isLoading}
        style={{ zIndex: 9999 }}
        sx={{ color: '#fff' }}>
        <CircularProgress color="inherit" size={60} />
      </Backdrop>
      <SubjectLayout.InnerContainer>
        <div className="datatable_content">
          <div className="user_data_table_title">Listagem de Coleções</div>
          <div style={{ width: '100%' }}>
            <Table.Filters
              filters={defaultCollectionFilters}
              currentFilterValues={initialFilter}
              onSubmit={(filter, filterObject) => {
                setCollectionPageFilters({
                  qs: filter,
                  object: filterObject,
                });
                setFilterPath(filter ? `&${filter}` : '');
              }}
            />
          </div>
          <div className="user_datatable_width">
            <DataTableCollections
              columns={columns}
              userItems={userItems}
              customStyles={customStyles}
              pending={pending}
              ExpandedComponent={ExpandedComponent}
              handleEditAndViewVideo={handleEditAndViewVideo}
              handleRemoveCollection={handleRemoveCollection}
              handleArchiveCollection={handleArchiveCollection}
              collectionDataTableGetVersions={collectionDataTableGetVersions}
              videoStatus={videoStatus}
              confirmDialogAction={confirmDialogAction}
              setConfirmDialogAction={setConfirmDialogAction}
              showConfirmationButton={showConfirmationButton}
            />
          </div>
          <div className="user_data_table_footer">
            <div className="user_data_table_footer_total">
              {itemsInitialPage} - {itemsPerPage} de {totalItems}
            </div>
            <div className="user_data_table_footer_pages">
              <KeyboardArrowLeftIcon
                className={
                  // eslint-disable-next-line eqeqeq
                  actualPage == 1
                    ? 'user_datatable_disabled_left_arrow'
                    : 'user_datatable_left_arrow'
                }
                onClick={() => videoDataTablePagination('left')}
              />
              {actualPage}
              <KeyboardArrowRightIcon
                className={
                  totalItems <= 10
                    ? 'user_datatable_disabled_right_arrow'
                    : actualPage === totalPages
                      ? 'user_datatable_disabled_right_arrow'
                      : 'user_datatable_right_arrow'
                }
                onClick={() => videoDataTablePagination('right')}
              />
            </div>
          </div>
        </div>
      </SubjectLayout.InnerContainer>
      <Modal
        confirmDialogAction={confirmDialogAction}
        setConfirmDialogAction={setConfirmDialogAction}
      />
      <ModalTitle
        open={openTitle}
        createCollection={createCollection}
        onClose={() => setOpenTitle(false)}
        CRUD_STATES={CRUD_STATES}
        setAuth={setAuth}
        auth={auth}
      />
    </SubjectLayout.Root>
  );
}

export default CollectionsNew;
